const CreateLabel = ({ label }) => {
  return <label className="mb-2 block text-sm font-medium text-slate-600">{label}</label>
}

export default CreateLabel
